import { createContext, useContext, useEffect, useState } from "react";
import { content } from "./translations";
import { track } from "@/lib/track";

const LanguageContext = createContext(null);

export const LanguageProvider = ({ children }) => {
  const [lang, setLangState] = useState(() => localStorage.getItem("hs_lang") || "");

  useEffect(() => {
    document.documentElement.lang = lang || "en";
  }, [lang]);

  const setLang = (l) => {
    localStorage.setItem("hs_lang", l);
    setLangState(l);
    track("language_selected", { lang: l });
  };

  const active = lang || "en";
  return (
    <LanguageContext.Provider
      value={{ lang: active, chosen: Boolean(lang), setLang, t: content[active] }}
    >
      {children}
    </LanguageContext.Provider>
  );
};

export const useLang = () => useContext(LanguageContext);
